import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex pa-3 flex-wrap justify-sm-space-between align-center justify-space-between" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Афиша")
const _hoisted_3 = { class: "text-sm-h6 text-no-wrap" }
const _hoisted_4 = { class: "text-sm-h6 text-no-wrap text-grey pl-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Схема")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Резервы")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Продажи оффлайн")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Продажи онлайн")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_Map = _resolveComponent("Map")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_EventOrders = _resolveComponent("EventOrders")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-0" }, {
    default: _withCtx(() => [
      (_ctx.userData)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            "max-width": "900px",
            class: "align-self-center justify-center ma-0 pa-0",
            elevation: "0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
                  "prepend-icon": "mdi-arrow-left",
                  class: "text-sm-h6"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$route.query.eventName), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString((new Date(_ctx.$route.query.eventDate).toLocaleString())) + " (код " + _toDisplayString(_ctx.$route.params.eventId) + ")", 1)
              ]),
              _createVNode(_component_v_tabs, {
                modelValue: _ctx.tab,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
                "align-tabs": "center",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tab, { value: "1" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, { value: "2" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, { value: "3" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, { value: "4" }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_window, {
                modelValue: _ctx.tab,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tab) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: "1" }, {
                    default: _withCtx(() => [
                      (_ctx.$route.params.eventId)
                        ? (_openBlock(), _createBlock(_component_Map, {
                            key: 0,
                            "event-id": _ctx.$route.params.eventId
                          }, null, 8, ["event-id"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "2" }, {
                    default: _withCtx(() => [
                      (_ctx.tab==='2')
                        ? (_openBlock(), _createBlock(_component_EventOrders, {
                            key: 0,
                            "order-type": "reserve",
                            "event-id": _ctx.$route.params.eventId,
                            onMsg: _ctx.msg
                          }, null, 8, ["event-id", "onMsg"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "3" }, {
                    default: _withCtx(() => [
                      (_ctx.tab==='3')
                        ? (_openBlock(), _createBlock(_component_EventOrders, {
                            key: 0,
                            "order-type": "offline",
                            "event-id": _ctx.$route.params.eventId,
                            onMsg: _ctx.msg
                          }, null, 8, ["event-id", "onMsg"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "4" }, {
                    default: _withCtx(() => [
                      (_ctx.tab==='4')
                        ? (_openBlock(), _createBlock(_component_EventOrders, {
                            key: 0,
                            "order-type": "online",
                            "event-id": _ctx.$route.params.eventId,
                            onMsg: _ctx.msg
                          }, null, 8, ["event-id", "onMsg"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _hoisted_9,
              _hoisted_10,
              _hoisted_11
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}